import BankInfoSection from "./BankInfoSection"
import BillingEmailsSection from "./BillingEmailsSection"
import { useEditAccountingGroupModal } from "./EditAccountingGroupModal"
import styles from "./OverviewSubTab.module.scss"
import SalonListSection from "./SalonListSection"
import UnpaidAmountsSection from "./UnpaidAmountsSection"

import type { BankAccountType } from "@/company_admin/gql/__generated__/graphql"

type AccountingGroupForOverview = {
	id: string
	name: string
	displayName: string
	bankCode: string
	bankBranchCode: string
	bankAccountType: BankAccountType
	bankAccountNumber: string
	bankAccountHolderName: string
	billingEmails: readonly string[]
}

type Props = {
	accountingGroup: AccountingGroupForOverview
	salonsRaw: readonly { salonId: number; salonName: string }[]
	souhlUnpaidAmount: number
	companyUnpaidAmount: number
	unpaidUntil: { year: number; month: number } | null
	refetchDetail: () => void
	refetchGroups: () => void
	refetchSettlements: () => void
}

const OverviewSubTab = ({
	accountingGroup,
	salonsRaw,
	souhlUnpaidAmount,
	companyUnpaidAmount,
	unpaidUntil,
	refetchDetail,
	refetchGroups,
	refetchSettlements,
}: Props) => {
	const salons = salonsRaw.map((s) => ({
		salonId: s.salonId,
		salonName: s.salonName,
	}))

	const editModal = useEditAccountingGroupModal({
		accountingGroup,
		refetchDetail,
		refetchGroups,
		refetchSettlements,
	})

	return (
		<div className={styles.overview}>
			<div className={styles.edit_button_container}>
				<button
					type="button"
					className={styles.edit_button}
					onClick={editModal.openModal}
				>
					経理グループを編集
				</button>
			</div>

			<BankInfoSection
				bankCode={accountingGroup.bankCode}
				bankBranchCode={accountingGroup.bankBranchCode}
				bankAccountType={accountingGroup.bankAccountType}
				bankAccountNumber={accountingGroup.bankAccountNumber}
				bankAccountHolderName={accountingGroup.bankAccountHolderName}
			/>

			<BillingEmailsSection
				billingEmails={[...accountingGroup.billingEmails]}
			/>

			<UnpaidAmountsSection
				souhlUnpaidAmount={souhlUnpaidAmount}
				companyUnpaidAmount={companyUnpaidAmount}
				unpaidUntil={unpaidUntil}
			/>

			<SalonListSection salons={salons} />

			{editModal.render()}
		</div>
	)
}

export default OverviewSubTab
